import { IValidatorFactoryService } from './validator-factory.service';
import { IPatternMetadata } from 'app/extensibility/metadatas/validator/pattern-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

import { format } from 'app/shared/utils/string.util';

/**
 * DO NOT USE THIS!
 * @deprecated Please use the new PatternValidatorFactoryService from shell-models-lib
 */
export class PatternValidatorFactoryService implements IValidatorFactoryService<IPatternMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'pattern';

    public createValidatorByMetadata(metadata: IPatternMetadata): IValidatorFn {
        return this.createValidator(metadata.pattern, metadata.errorMessage, metadata.patternFlags);
    }

    public createValidator(pattern: string | RegExp, errMsg?: string, patternFlags?: string): IValidatorFn {
        const regex = typeof pattern === 'string' ? new RegExp(pattern, patternFlags) : new RegExp(pattern);
        const errorMessage = errMsg != null ? errMsg : format(stringResources.Validator_ErrorMessage_Pattern, regex.source);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value == null || value === '') {
                return null;
            }
            return regex.test(value) ? null : errorMessage;
        };
    }

    // fixed start/end pattern validator: [entity type] name should start/end with ...
    public createValidatorStartEnd(pattern: string | RegExp, errMsg: string, patternFlags?: string): IValidatorFn {
        const regex = typeof pattern === 'string' ? new RegExp(pattern, patternFlags) : new RegExp(pattern);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value == null || value === '') {
                return null;
            }
            return regex.test(value) ? null : errMsg;
        };
    }
}
